import React, {useState} from 'react';
import {useDropdowns} from "../../../../hooks/useDropdowns";
import WorkforceDetailsFieldComponent from "../../../../components/WorkForce/WorkforceDetailsFieldComponent";
import {Input, Select} from "antd";
import {useDispatch, useSelector} from "react-redux";
import TextArea from "antd/es/input/TextArea";

const MeterLoggerCaseDetails = () => {
    const {state} = useDropdowns();
    const { workforceCaseDetails } = useSelector((state) => state.Workforce);

    return (
        <div className="grid grid-cols-2 gap-5">

            <WorkforceDetailsFieldComponent fieldName={"Case ID"} fieldId={"caseIdStr"}>
                <Input
                    disabled={true}
                    placeholder=""
                    id={"caseIdStr"}
                    value={workforceCaseDetails?.caseIdStr}
                    onChange={() => {
                    }}
                />
            </WorkforceDetailsFieldComponent>

            <WorkforceDetailsFieldComponent
                fieldName={"Meter ID (Old)"}
                fieldId={"meterId"}
            >
                <Select
                    disabled={true}
                    showSearch
                    placeholder={"Select a value"}
                    value={workforceCaseDetails?.device?.meterSN}
                    onChange={() => {
                    }}
                    options={state?.devices.map((statusTypes) => {
                        return {
                            label: statusTypes?.name,
                            value: statusTypes?.id,
                        };
                    })}
                    filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    className={
                        "w-full font-light placeholder:text-light-grey-500"
                    }
                />
            </WorkforceDetailsFieldComponent>


            <WorkforceDetailsFieldComponent
                fieldName={"Creation Date"}
                fieldId={"creationDate"}
            >
                <Input
                    disabled={true}
                    id={"creationDate"}
                    value={workforceCaseDetails?.createdAt}
                    onChange={() => {
                    }}
                />
            </WorkforceDetailsFieldComponent>

            <WorkforceDetailsFieldComponent
                fieldName={"Meter Manufacturer"}
                fieldId={"meterManufacturer"}
            >
                <Input
                    disabled={true}
                    placeholder=""
                    id={"meterManufacturer"}
                    value={workforceCaseDetails?.device?.meterMenufacturer}
                    onChange={() => {
                    }}
                />
            </WorkforceDetailsFieldComponent>


            <WorkforceDetailsFieldComponent
                fieldName={"Created By"}
                fieldId={"createdBy"}
            >
                <Input
                    disabled={true}
                    placeholder=""
                    id={"createdBy"}
                    value={workforceCaseDetails?.createdBy}
                    onChange={() => {
                    }}
                />
            </WorkforceDetailsFieldComponent>

            <WorkforceDetailsFieldComponent
                fieldName={"Installation Date"}
                fieldId={"installationDate"}
            >
                <Input
                    disabled={true}
                    placeholder=""
                    id={"installationDate"}
                    value={workforceCaseDetails?.device?.installationDate}
                    onChange={() => {
                    }}
                />
            </WorkforceDetailsFieldComponent>


            <WorkforceDetailsFieldComponent
                fieldName={"Case Type"}
                fieldId={"caseType"}
            >
                <Input
                    disabled={true}
                    placeholder=""
                    id={"caseType"}
                    value={workforceCaseDetails?.caseType?.name}
                    onChange={() => {
                    }}
                />
            </WorkforceDetailsFieldComponent>


            <WorkforceDetailsFieldComponent fieldName={"Region"} fieldId={"region"}>
                <Input
                    disabled={true}
                    placeholder=""
                    id={"region"}
                    value={workforceCaseDetails?.region}
                    onChange={() => {
                    }}
                />
            </WorkforceDetailsFieldComponent>


            <WorkforceDetailsFieldComponent
                fieldName={"Assign To"}
                fieldId={"assignTo"}
            >
                <Select
                    disabled={true}
                    placeholder={"Select a value"}
                    id={"technicianGroupId"}
                    value={workforceCaseDetails?.technicianGroup?.name}
                    onChange={() => {
                    }}
                    options={state?.technicianGroupsDropdown?.map((statusTypes) => {
                        return {
                            label: statusTypes?.name,
                            value: statusTypes?.id,
                        };
                    }) ?? []}
                    className={
                        "w-full font-light placeholder:text-light-grey-500"
                    }
                />
            </WorkforceDetailsFieldComponent>

            <WorkforceDetailsFieldComponent
                fieldName={"Consumer Name"}
                fieldId={"consumerName"}
            >
                <Input
                    disabled={true}
                    placeholder=""
                    id={"consumerName"}
                    value={workforceCaseDetails?.device?.consumerName}
                    onChange={() => {
                    }}
                />
            </WorkforceDetailsFieldComponent>


            <WorkforceDetailsFieldComponent fieldName={"Logger Manufacturer"} fieldId={"loggerManufacturer"}
                                            className={"col-start-2"}>
                <Input
                    disabled={true}
                    placeholder=""
                    id={"loggerManufacturer"}
                    value={workforceCaseDetails?.device?.loggerMenufacturer}
                    onChange={() => {
                    }}
                />
            </WorkforceDetailsFieldComponent>

            <WorkforceDetailsFieldComponent fieldName={"Simcard No"} fieldId={"simcardNo"} className={"col-start-2"}>
                <Input
                    disabled={true}
                    placeholder=""
                    id={"simcardNo"}
                    value={workforceCaseDetails?.device?.simCardSN}
                    onChange={() => {
                    }}
                />
            </WorkforceDetailsFieldComponent>

            <WorkforceDetailsFieldComponent fieldName={"Address"} fieldId={"address"} className={"col-start-2"}>
                <TextArea
                    disabled={true}
                    placeholder=""
                    id={"address"}
                    value={workforceCaseDetails?.fullAddress}
                    onChange={() => {
                    }}
                />
            </WorkforceDetailsFieldComponent>
        </div>
    );

}

export default MeterLoggerCaseDetails;